import React from "react";
import styles from "./Header.module.scss";

const Header = () => {
  return (
    <div className={styles.header}>
      <div>Design Studio:</div>
      <div>Templates Gallery</div>
    </div>
  );
};

export default Header;
